export const CAROUSEL_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
}
